var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParseForm',{ref:"bus",attrs:{"formId":_vm.formId,"formParams":_vm.formParams,"emit":_vm.emit,"opCode":_vm.opCode,"reMountPage":_vm.reMountPage,"funcOnChange":_vm.funcOnChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }